module.exports = __webpack_public_path__ + "static/media/MasterPlan-FINAL.44c03a4b.jpg";